import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from '../../../services/registry.service';
import {AuthService} from '../../../../../services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {CampaignService} from '../../../../admin/services/campaign.service';

@Component({
    selector: 'app-campaign-subscription-confirmed',
    templateUrl: './campaign-subscription-confirmed.component.html',
    styleUrls: ['./campaign-subscription-confirmed.component.css']
})
export class CampaignSubscriptionConfirmedComponent implements OnInit, OnDestroy {


    coupon_code = '';

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private campaignService: CampaignService,
                private route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {

        let hash = this.route.snapshot.paramMap.get('hash');

        this.campaignService.confirmSubscription(hash).subscribe(result => {

            //success
            this.coupon_code = result.coupon_code;
            localStorage.setItem('discount_code',this.coupon_code);

        });

    }

    ngOnDestroy(): void {
    }

}
